// Mirrors the server's canViewHealinkImpact: the practice flag AND the provider's own.
// Both ride on login-time Redux snapshots; the server re-checks either way, and a 403
// from it revokes the practice flag locally (see useImpact).
interface ImpactUserState {
  user?: {
    user?: {
      defaultPractice?: { attributedMetricsEnabled?: boolean };
      featureFlags?: Record<string, boolean> | null;
    };
  };
}

export const selectCanViewImpact = (state: ImpactUserState): boolean =>
  Boolean(state?.user?.user?.defaultPractice?.attributedMetricsEnabled) &&
  Boolean(state?.user?.user?.featureFlags?.healinkImpact);
